<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <!-- <app-page-banner title="Contact us" subtitle="Contact us"></app-page-banner> -->
        <!-- INNER PAGE BANNER END -->

        <!-- CONTACT FORM -->
        <div class="section-full bg-white nobreadcrump">
            <div class="section-content contact-section">
                <div class="container">
                    <div class="contact-one">
                        <!-- CONTACT FORM-->
                        <div class="row no-gutters d-flex justify-content-center flex-wrap align-items-center">

                            <div class="col-lg-7 col-md-12">
                                <div class="contact-form-outer site-bg-gray">
                                    <form class="cons-contact-form" [formGroup]="RegisterForm" autocomplete="off" (ngSubmit)="onSubmit()">


                                        <!-- TITLE START-->
                                        <div class="section-head left wt-small-separator-outer">
                                            <h3 class="wt-title m-b30">Get in Touch</h3>
                                            <p>Feel Free to Contact us any time. we will get back to you as soon as we
                                                can't</p>
                                        </div>
                                        <!-- TITLE END-->

                                        <div class="row">

                                          <div class="col-lg-12 col-md-12">
                                            <label>Name<b class="star">*</b></label>
                                            <div class="form-group">
                                                <input type="text" placeholder="Name" formControlName="name" maxlength="100" class="form-control">
                                                <div *ngIf="RegisterForm.get('name')?.invalid && RegisterForm.get('name')?.touched" class="text-danger">
                                                    <span *ngIf="RegisterForm.get('name')?.errors?.required">Please Enter the Name.</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-12">
                                          <label>Email<b class="star">*</b></label>
                                          <div class="form-group">
                                              <input type="text" class="form-control" placeholder="Email" formControlName="email">
                                              <div *ngIf="RegisterForm.get('email')?.invalid && RegisterForm.get('email')?.touched" class="text-danger">
                                                  <span *ngIf="RegisterForm.get('email')?.errors?.required">Please Enter the Email.</span>
                                                  <span *ngIf="RegisterForm.get('email')?.errors?.email">Please Enter a valid Email.</span>
                                              </div>
                                          </div>
                                      </div>

                                            <div class="col-lg-6 col-md-12">
                                                <label>Mobile<b class="star">*</b></label>
                                                <div class="form-group">
                                                  <input type="text" placeholder="Phone" formControlName="mobile" class="form-control" />
                                                  <div *ngIf="RegisterForm.get('mobile')?.invalid && RegisterForm.get('mobile')?.touched" class="text-danger">
                                                    <span *ngIf="RegisterForm.get('mobile')?.errors?.required">Please Enter the Mobile.</span>

                                                    <span *ngIf="RegisterForm.get('mobile')?.errors?.pattern">Enter a valid 10-digit mobile number.</span>
                                                  </div>
                                                </div>
                                              </div>
                                              

                                            <div class="col-lg-12 col-md-12">
                                                <div class="form-group">
                                                    <label>Subject</label>
                                                    <input type="text" placeholder="Subject" formControlName="subject">
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <label>Message</label>
                                                    <textarea name="message" class="form-control" rows="4"
                                                        placeholder="Message" formControlName="message"></textarea>
                                                </div>
                                            </div>
                                            <!-- <div class="captcha-container {{ config.cssClass }}">
                                                <div class="d-flex flex-wrap recaptcha-input">
                                                  <div class="captcha-actions">
                                                    <input type="text" [(ngModel)]="captch_input"  name="captcha" [ngModelOptions]="{standalone: true}" 
                                                    placeholder="Enter the CAPTCHA" (input)="checkCaptcha()" >
                                                    
                                                  </div>
                                                  <canvas id="captcahCanvas" width="325" height="80"></canvas>
                                                  <a class="cpt-btn "   (click)="reloadCaptcha()" >&#x21bb;</a>
                                                </div>
                                                           
                                              </div> -->
                                              <div class="col-lg-6 col-md-6">
                                                <div class="form-group captcha-container">
                                                  <div class="captcha-actions mb-3">
                                                    <label>CAPTCHA</label>
                                                    <input type="text" formControlName="capicha" class="form-control" placeholder="Enter the CAPTCHA" />
                                                    <div *ngIf="capicha.invalid && capicha.touched" class="text-danger">
                                                      Invalid CAPTCHA
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              
                                              <div class="col-lg-6 col-md-6">
                                                <div class="captcha-display">
                                                  <canvas id="captcahCanvas"></canvas>
                                                  <a class="cpt-btn refresh-btn" (click)="reloadCaptcha()">&#x21bb;</a>
                                                </div>
                                              </div>
                                              
                                              
                                

                                            <div class="col-md-12">
                                                <button type="submit" class="site-button sb-bdr-dark">Submit
                                                    Now</button>
                                                    
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="contact-info site-bg-black"
                                    style="background-image: url(assets/images/background/footer-map.png);">
                                    
                                    <div class="section-head left wt-small-separator-outer when-bg-dark">
                                        <h3 class="wt-title">Clinic Info</h3>
                                    </div>
                                    

                                    <div class="contact-info-section">

                                        <div class="c-info-column">
                                            <span class="m-t0">Address</span>
                                            <p>Unit Nos. 101A & 101B, 1st Floor, AVA Court, Malibu Towne, Sohna Road</p>
                                        </div>

                                        <div class="c-info-column">
                                            <span class="m-t0">City</span>
                                            <p>Gurugram</p>
                                        </div>

                                        

                                        <div class="c-info-column">
                                            <span class="m-t0">State</span>
                                            <p>Haryana</p>
                                        </div>

                                        <div class="c-info-column">
                                            <span class="m-t0">Country</span>
                                            <p>India</p>
                                        </div>

                                        <div class="c-info-column">
                                            <span class="m-t0">Pin Code</span>
                                            <p>122018</p>
                                        </div>

                                        <div class="c-info-column">
                                            <span class="m-t0">Phone number</span>
                                            <p>8069095550</p>
                                        </div>

                                        <div class="c-info-column">
                                            <span class="m-t0">Email address</span>
                                            <p>contact&#64;soulspacecare.com</p>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- GOOGLE MAP -->
        <!-- <div class="section-full">
            <div class="container">
              <div class="gmap-outline p-b120">
                <google-map 
                  [center]="center" 
                  height="500px" 
                  width="100%" 
                  [zoom]="zoom">
                </google-map>
              </div>
            </div>
          </div>
           -->

           <div class="section-full pb-0 pb-5 contact-section">
            <div class="container mt-5">
              <div class="gmap-outline">
                <google-map
                  height="500px"
                  width="100%"
                  [center]="center"
                  [zoom]="zoom">
                </google-map>
              </div>
            </div>
          </div>
          
          

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>